module.exports = __webpack_public_path__ + "static/img/victim-kids.27a73a91.png";